import request from '@/utils/request';

enum Api {
  ValidateCode = '/captcha/getValidateCode',  //验证图片验证码
  Login = '/sys/login',   //登录
  Logout = '/doLogout',
  ChangePassword = '/sys/changePassword',   //修改用户密码
  GetUserPermissions = '/sys/getPermission',  //获取用户菜单和权限
}

// 接口返回数据类型定义
export interface ApiResponse<T = any> {
  status: number;
  message: string;
  data: T;
  success: boolean;
}

// 登录请求参数
export interface LoginParams {
  password: string;
  mobilePhone: string;
  domainInfo: string;
}

// 登录返回数据
export interface LoginResult {
  token: string;
  userId: string;
  userName: string;
  mobilePhone: string;
  projectId: number;
  language: string;
}

// 菜单项
export interface MenuItem {
  id: string;
  status: string;
  createBy: string;
  createTime: string;
  modifyBy: string | null;
  modifyTime: string | null;
  tenantId: string;
  pid: string;
  menuType: string;
  menuCode: string;
  menuName: string;
  menuPath: string | null;
  menuLevel: string;
  remark: string | null;
  isSuper: string;
  isExternal: string | null;
  sort: number;
}

// 用户权限数据
export interface UserPermissionsResult {
  menus: MenuItem[];
  permissions: string[];
}

// 验证码验证参数
export interface ValidateCodeParams {
  uuid: string;
  code: string;
}

/**
 * 验证图片验证码
 */
export const validateCode = (params: ValidateCodeParams): Promise<ApiResponse<null>> => {
  return request(Api.ValidateCode, {
    method: 'GET',
    params,
  });
};

/**
 * 用户登录
 */
export const login = (data: LoginParams): Promise<ApiResponse<LoginResult>> => {
  return request(Api.Login, {
    method: 'POST',
    data,
  });
};

/**
 * 获取用户菜单和权限
 */
export const getUserPermissions = (projectId: number): Promise<ApiResponse<UserPermissionsResult>> => {
  return request(Api.GetUserPermissions, {
    method: 'GET',
    params: { projectId },
  });
};

/**
 * 用户登出
 */
export const logout = (): Promise<ApiResponse<null>> => {
  return request(Api.Logout, {
    method: 'POST',
  });
};

/**
 * 修改密码
 */
export const changePassword = (data: {
  oldPassword: string;
  newPassword: string;
}): Promise<ApiResponse<null>> => {
  return request(Api.ChangePassword, {
    method: 'POST',
    data,
  });
};
